import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Product } from '../product';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Navbar } from '../../components/navbar/navbar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import {
  ApplicationUpdateRequest,
  CommonService,
  ApplicationDetail,
} from '../../services/common.service';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-product-plan-details',
  imports: [
    CommonModule,
    Navbar,
    MatTabsModule,
    MatButtonModule,
    MatIconModule,
    CdkAccordionModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    RouterModule,
    TranslateModule,
  ],
  templateUrl: './product-plan-details.html',
  styleUrl: './product-plan-details.scss',
})
export class ProductPlanDetails {
  productId: any;
  planId: any;
  plan: any;
  constructor(
    public productService: Product,
    private route: ActivatedRoute,
    private commonService: CommonService
  ) {}
  products: any;
  productOptions: any[] = [];
  paymentTerms: any[] = [];
  productCoverages: any[] = [];

  currentIndex = 0;
  items = ['ລາຍລະອຽດ'];
  expandedIndex = 0;

  selectedOption: any = null;
  selectedProduct: any = null;
  selectedPlan: any = null;
  selectedTerm: any = null;
  insuredData: any = null;

  shouldHideTotalPremiumAmount: boolean = false;
  shouldHideCoverageAmount: boolean = false;

  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.productId = params.get('id');
      this.planId = params.get('subId');
    });

    this.productService.findProductsPlanByProductId(this.productId).subscribe((res: any) => {
      this.products = res.find((p: any) => p.planId === this.planId);
    });

    this.productService.findProductPlanById(this.productId, this.planId).subscribe((res: any) => {
      this.plan = res.plan;
      this.paymentTerms = res.paymentTerms;
      this.productOptions = res.productOptions;
      this.productCoverages = res.productCoverages;

      console.log(res);

      const calculatePremiumRequest = {
        productOption: this.productOptions[0],
        product: res.product,
        plan: this.plan,
        paymentTerm: res.paymentTerms[0],
      };

      this.calculateAndSetUpPremium(calculatePremiumRequest);
      this.shouldHideCoverageAmount = !this.productOptions.length;
    });
  }

  height: boolean = false;

  heightOp() {
    this.height = true;

    if (this.height == true) {
      setTimeout(() => {
        console.log('scroll');

        this.scrollToSection();
      }, 100);
    }
  }

  heightCl() {
    this.height = false;
  }

  scrollToSection() {
    const el = document.getElementById('target');
    el?.scrollIntoView({ behavior: 'smooth' });
  }

  private getMonthsByPaymentTerm(code: string): number {
    // Map payment term codes to months
    const termMonths: { [key: string]: number } = {
      MON: 1,
      '3MO': 3,
      '6MO': 6,
      YEL: 12,
    };
    return termMonths[code] || 1;
  }

  handleProductOptionChange(optionId: string): void {
    this.selectedOption = this.productOptions.find((o) => o.id === optionId);

    if (this.selectedOption) {
      const calculatePremiumRequest = {
        productOption: this.selectedOption,
        product: this.products,
        plan: this.plan,
        paymentTerm: this.paymentTermsSL,
        // insuredAge: this.insuredData?.insuredAge,
      };

      this.calculateAndSetUpPremium(calculatePremiumRequest);
    }
  }

  handleProductTermChange(termId: number): void {
    this.selectedTerm = this.paymentTerms.find((t) => t.termId === termId);

    if (this.selectedOption == null) {
      this.selectedOption = this.productOptions[0];
      // console.log(this.productOptions[0]);
      // console.log(this.selectedOption);
    }

    if (this.selectedTerm) {
      const calculatePremiumRequest = {
        productOption: this.selectedOption,
        product: this.products,
        plan: this.plan,
        paymentTerm: this.selectedTerm,
        // insuredAge: this.insuredData?.insuredAge,
      };

      this.calculateAndSetUpPremium(calculatePremiumRequest);
    }
  }

  updatePremiumAmtPerTime: any;
  updatePremiumAmtPerYear: any;
  updateTotalPremiumAmt: any;
  paymentTermsSL: any;

  private async calculateAndSetUpPremium(request: any): Promise<void> {
    if (!request.product || !request.plan || !request.paymentTerm) {
      return;
    }

    // console.log(request);

    const { product, plan, paymentTerm } = request;
    // console.log('plan', plan);
    // console.log('paymentTerm', paymentTerm);

    let premiumAmtPerYear = 0;
    let premiumAmtPerTime = 0;
    let totalPremiumAmt = 0;

    console.log(paymentTerm);

    // Get premium by payment term
    let premiumByPaymentTerm = null;
    try {
      premiumByPaymentTerm = await this.commonService
        .getPremiumByPaymentTerm(plan?.planId, paymentTerm?.code)
        .toPromise();
    } catch (error) {
      console.error('Error fetching premium by payment term:', error);
      premiumByPaymentTerm = null;
    }

    const numOfMonth = this.getMonthsByPaymentTerm(paymentTerm.code);
    console.log('paymentTerm.code', paymentTerm.code);
    console.log('numOfMonth', numOfMonth);

    // Premium calculation logic based on premium type
    if (plan.premiumTypeId === 1) {
      // FixAmtDay
      premiumAmtPerTime = plan.premium * (numOfMonth * 30);
      premiumAmtPerYear = (12 / numOfMonth) * premiumAmtPerTime;
    } else if (plan.premiumTypeId === 2) {
      // FixAmtYear
      premiumAmtPerYear = plan.premium;

      console.log('plan', plan);
      console.log('premiumAmtPerYear', premiumAmtPerYear);

      if (premiumByPaymentTerm == null) {
        premiumAmtPerTime = premiumAmtPerYear / (12 / numOfMonth);
      } else {
        console.log(premiumByPaymentTerm);

        premiumAmtPerTime = Number(premiumByPaymentTerm.sumInsured);
      }
      console.log('premiumAmtPerTime', premiumAmtPerTime);
      console.log('premiumByPaymentTerm', premiumByPaymentTerm);
    } else if (plan.premiumTypeId === 3) {
      // Percent
      const coverageAmt = request.productOption?.amount || 0;
      premiumAmtPerYear = (plan.premium / 100) * coverageAmt;
      premiumAmtPerTime = premiumAmtPerYear / (12 / numOfMonth);
    }

    if (plan.paymentYear != null) {
      totalPremiumAmt = Number(premiumAmtPerYear * plan.paymentYear);
    }

    // Round up to nearest thousand for premiumAmtPerTime and ceiling for others
    premiumAmtPerTime = Math.ceil(premiumAmtPerTime / 1000) * 1000;
    premiumAmtPerYear = Math.ceil(premiumAmtPerYear);
    totalPremiumAmt = Math.ceil(totalPremiumAmt);

    // this.updateApplicationRequest.premiumAmtPerYear = premiumAmtPerYear;
    // this.updateApplicationRequest.premiumAmtPerTime = premiumAmtPerTime;
    // this.updateApplicationRequest.totalPremiumAmt = totalPremiumAmt;

    this.updatePremiumAmtPerTime = premiumAmtPerTime;
    this.updatePremiumAmtPerYear = premiumAmtPerYear;
    this.updateTotalPremiumAmt = totalPremiumAmt;

    this.shouldHideTotalPremiumAmount = totalPremiumAmt === 0;

    console.log(numOfMonth);

    this.paymentTermsSL = this.paymentTerms.find((t) => t.monthRate === numOfMonth);
  }
}
